import { paths as CustomerCommunicationPaths } from '@luxuryescapes/contract-customer-communication';

import { request } from '~/services/common';

import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';

type HeroPlannerCadenceGetContract =
  CustomerCommunicationPaths['/api/customer-communication/v1/todays-escapes-schedule/hero-planner/country-groups/{countryGroup}/countries/{country}/states/{state}/cities/{city}/segments/{segment}/cadences']['get'];

function mapHeroPlannerCadence(
  external: Utils.ArrayElement<
    HeroPlannerCadenceGetContract['responses']['200']['content']['application/json']['result']
  >,
): CustomerCommunication.HeroPlannerStateSegment {
  return {
    id: external.id,
    name: external.name,
  };
}

async function requestGetHeroPlannerCadences(
  brand: string,
  countryGroup: string,
  country: string,
  state: string,
  city: string,
  segment: string,
) {
  if (!brand) throw 'missing brand';
  if (!countryGroup) throw 'missing countryGroup';
  if (!country) throw 'missing country';
  if (!state) throw 'missing state';
  if (!city) throw 'missing city';
  if (!segment) throw 'missing segment';

  const url = makeCustomerCommunicationV1URL(
    `/todays-escapes-schedule/hero-planner/country-groups/${countryGroup}/countries/${country}/states/${state}/cities/${city}/segments/${segment}/cadences`,
  );
  url.searchParams.set('brand', brand);

  return request(url.toString(), {
    method: 'GET',
    credentials: 'include',
  })
    .then((response: HeroPlannerCadenceGetContract['responses']['200']['content']['application/json']) => {
      return response.result.map(mapHeroPlannerCadence);
    })
    .catch((error) => {
      throw JSON.stringify(error, null, 2);
    });
}

export default requestGetHeroPlannerCadences;
